<div
  class="loader"
  [style.width]="!size ? customSize : ''"
  [style.height]="!size ? customSize : ''"
  [ngClass]="['loader-' + size]"
>
  <svg class="loader-svg" viewBox="0 0 200 200">
    <circle class="circle" cx="100" cy="100" r="88" />
    <circle class="arco" cx="100" cy="100" r="88" />
  </svg>
</div>
